// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeader_root__3rZUL","content":"PageHeader_content__1VOQ1","end":"PageHeader_end__1Y_Z5"};